<template>
  <div class="tag js-tag js-transition_item_common">
    <ul class="tag__list">
      <li
        v-for="item in tag"
        :key="item"
        class="tag__item js-tag_item"
        v-on:click="onClick($event, item)"
      >
        <span class="tag__item-txt">
          {{ item }}
          <CrossSvg class="tag__item-icon"></CrossSvg>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import CrossSvg from "./Cross.svg";
export default {
  components: {
    CrossSvg
  },
  methods: {
    onClick(e, tag) {
      e.currentTarget.classList.toggle("active");

      this.$store.commit("sTag", tag);
    }
  },
  computed: {
    tag() {
      return this.$store.state.tag;
    }
  }
};
</script>

<style lang="scss" scoped>
.tag {
  // height: 0;
  overflow: hidden;
  margin-top: 10px;
  // transition: height 0.8s $easeOutExpo;

  // &.active {
  //   height: 42px;
  // }

  &__list {
    margin-top: 10px;
    // padding-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  &__item {
    font-size: 14px;
    padding: 6px 8px;
    border: 1px solid #adadad;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.5s $easeOutExpo 0s;
    position: relative;

    margin-bottom: 10px;

    &:not(:last-child) {
      margin-right: 10px;
    }

    @include min(769) {
      &:hover {
        border-color: transparent;
        background-color: #000;

        .tag__item-txt {
          color: #fff;
        }

        .tag__item-icon {
          transform: translateY(-50%) rotate(180deg) !important;
        }
      }
    }

    &.active {
      border-color: transparent;
      padding-right: 21px;
      background-color: #000;

      .tag__item-txt {
        color: #fff;
      }

      .tag__item-icon {
        // transform: translateY(-50%) rotate(180deg) !important;
        opacity: 1;
      }
    }
  }

  &__item-txt {
    transition: all 0.5s $easeOutExpo 0s;
    color: #adadad;
    position: relative;
  }

  &__item-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%) rotate(0);
    right: -15px;
    z-index: 1;
    opacity: 0;
    transition: all 0.5s $easeOutExpo 0s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Tag/_index.vue